console.log('Custom JS Loaded');

const galleryDesktopItems = document.querySelectorAll('.product-gallery__media-list-wrapper .product-gallery__media');
const multiColCarousels = document.querySelectorAll('.slider-wrapper');

if(typeof galleryDesktopItems != 'undefined' && galleryDesktopItems != null) {
    let imgArr = [];
    let zoomBtnArr = [];
    
    galleryDesktopItems.forEach((media, index) => {
        imgArr[index] = media.querySelector('img');
        zoomBtnArr[index] = media.querySelector('.product-gallery__zoom button');

        imgArr[index].addEventListener('click', function() {
            zoomBtnArr[index].click();
        });
    });
}

if(typeof multiColCarousels != 'undefined' && multiColCarousels != null) {
    let prevBtns = [];
    let nextBtns = [];
    let slides = [];
    let slidesContainers = [];

    multiColCarousels.forEach(function(carousel, i) {
        slides[i] = carousel.querySelector('.slide');
        slidesContainers[i] = carousel.querySelector('.slides-container');

        prevBtns[i] = carousel.querySelector(".slide-arrow-prev");
        nextBtns[i] = carousel.querySelector(".slide-arrow-next");

        nextBtns[i].addEventListener("click", () => {
            const slideWidth = slides[i].clientWidth;
            let scrollLeft = 0;
            slidesContainers[i].scrollLeft += slideWidth;
            
            if(prevBtns[i].classList.contains('hide')) {
                prevBtns[i].classList.remove('hide');
            }
            
            scrollLeft = slidesContainers[i].scrollLeft + (slideWidth * 2);
            
            console.log(scrollLeft);
            if(scrollLeft >= slidesContainers[i].scrollWidth) {
                nextBtns[i].classList.add('hide');
            }
        });

        prevBtns[i].addEventListener("click", () => {
            const slideWidth = slides[i].clientWidth;
            let scrollLeft = 0;
            
            slidesContainers[i].scrollLeft -= slideWidth;
            
            if(nextBtns[i].classList.contains('hide')) {
                nextBtns[i].classList.remove('hide');
            }            
            scrollLeft = slidesContainers[i].scrollLeft - slideWidth;
            if(scrollLeft <= 0) {
                prevBtns[i].classList.add('hide');
            }
        });
    });
}

document.addEventListener("DOMContentLoaded", function() {
    const readMoreDivs = document.querySelectorAll('.read-more-content');
    let readMoreBtns = [];

    if(readMoreDivs.length > 0) {
        readMoreDivs.forEach(function(el, index) {
            readMoreBtns[index] = el.querySelector('.read-more-content-btn');
            
            readMoreBtns[index].addEventListener('click', function(e) {
                e.preventDefault();
                readMoreDivs[index].classList.toggle("show");
                readMoreBtns[index].style.display = 'none';
            });
        });
    }
});